/** Services list API expects an integer vehicle_id; use -1 when none is selected. */
export function resolveServicesVehicleId(vehicleId: unknown): number {
  if (vehicleId == null || vehicleId === "" || vehicleId === false) {
    return -1;
  }

  const parsed = Number(vehicleId);
  if (!Number.isFinite(parsed)) {
    return -1;
  }

  return Math.trunc(parsed);
}
